export default () => ({
  item: {
    '&.active': {
      background: '#515151',
    },
  },
});
